<template>
  <v-container grid-list-md fluid>
    <v-layout column>
      <v-flex>
        <v-toolbar color="#eee" class="elevation-0 secondary--text mb-4" style="background: transparent">
          <v-toolbar-title>ITENS A VENDA</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock && smartLockAtivo" v-on="on" icon :color="oferta ? '' :'secondary'" @click="oferta = !oferta, promocao = false">
                <v-icon>{{oferta ? 'close' : 'add_shopping_cart'}}</v-icon>
              </v-btn>
            </template>
            <span>{{oferta ? 'Recolher' : 'Cadastrar nova oferta'}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock && smartLockAtivo" v-on="on" icon color="secondary" @click="dialogTipoDesconto = true">
                <v-icon>paid</v-icon>
              </v-btn>
            </template>
            <span>Tipo de desconto aplicado</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock && smartLockAtivo" v-on="on" icon color="secondary" @click="mostrar = true">
                <v-icon>local_gas_station</v-icon>
              </v-btn>
            </template>
            <span>Configurar exibição do preço do combustível</span>
           </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock && smartLockAtivo" v-on="on" icon color="secondary" @click="promocao = true">
                <v-icon>whatshot</v-icon>
              </v-btn>
            </template>
            <span>Cadastrar nova promoção</span>
           </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock && smartLockAtivo" v-on="on" icon color="secondary" @click="codigo = true">
                <v-icon>confirmation_number</v-icon>
              </v-btn>
            </template>
            <span>Código promocional</span>
           </v-tooltip>
           <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :disabled="!smartLock && smartLockAtivo" v-on="on" icon color="secondary" @click="dialogCadItem = true">
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>Cadastrar novo Item</span>
           </v-tooltip>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-slide-x-transition>
      <v-layout wrap justify-space-between v-if="oferta" class="mb-4 ml-2 mr-2 pa-4" style="background-color:#F5F5F5">
      <v-flex xs12 class="ma-0 pa-0">
        <h2 class="text-xs-center secondary--text" style="font-weight: normal;">
          Cadastre Uma Nova Oferta
        </h2>
      </v-flex>
      <v-flex xs12 sm6 md4 class="ma-0 pa-0">
        <v-tooltip bottom>
          <v-switch slot="activator" class="ml-4" v-model="tem_desconto_em_reais" :disabled="posto && posto.tipo_desconto !== 2" color="secondary">
            <template v-slot:label>
                Tem Desconto em Reais
            </template>
          </v-switch>
          <span>{{ tem_desconto_em_reais ? 'Desativar Desconto Dado em Reais' : 'Ativar Desconto Dado em Reais' }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12 sm6 md4 v-if="tem_assinatura" class="ma-0 pa-0">
        <v-tooltip left>
          <v-switch slot="activator" class="ml-4" v-model="cadOferta.para_assinantes" color="secondary">
            <template v-slot:label>
                Para Assinantes
            </template>
          </v-switch>
          <span>{{ cadOferta.para_assinantes ? 'Desativar Oferta Apenas Para Assinantes' : 'Ativar Oferta Apenas Para Assinantes' }}</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs12 sm12 md5 class="ma-0 pa-0">
        <span>Selecionar Categoria</span>
        <v-autocomplete
          label="Categorias"
          :items="categorias"
          item-text="nome"
          item-value="id"
          v-model="cadOferta.categoria"
          outline
          hide-details
          single-line
        />
      </v-flex>
      <v-flex xs12 sm12 md5 class="ma-0 pa-0">
        <span>Selecionar um item</span>
        <v-autocomplete
          label="Itens"
          :items="[{ nome: 'Todos os Itens', id: 0 }, ...todos_itens]"
          item-text="nome"
          item-value="id"
          v-model="cadOferta.item"
          outline
          hide-details
          single-line
        />
      </v-flex>
      <v-flex xs12 sm6 md5 style="flex-direction: row; display: flex;" class="ma-0 pa-0">
        <v-flex xs12 class="pa-0 ma-0 mt-2">
          <span>
            Desconto em Reais
          </span>
          <v-text-field
            :disabled="(!smartLock && smartLockAtivo) || !tem_desconto_em_reais || (posto && posto.tipo_desconto !== 2)"
            outline
            id="reais"
            label="Valor de Desconto"
            v-money="money"
            v-model.lazy="desconto_em_reais"
            hint="Valor a ser subtraido do valor do item"
            :rules="tem_desconto_em_reais ? [
              () => cadOferta.desconto_em_reais > 0 || 'O desconto da oferta deve ser de no mínimo R$ 0,01 Centavo',
              () => cadOferta.desconto_em_reais <= 4 || 'O valor máximo de desconto de uma oferta R$ 4,00',
              (v) => !!v || 'Desconto inválido',
            ] : []"
          />
        </v-flex>
      </v-flex>
      <v-flex xs12 sm6 md5 style="flex-direction: row; display: flex;" class="ma-0 pa-0">
        <v-flex xs12 class="pa-0 ma-0 mt-2">
          <span>
            Percentual de desconto
          </span>
          <v-text-field
            :disabled="(!smartLock && smartLockAtivo) || tem_desconto_em_reais"
            outline
            label="Percentual desconto"
            type="number"
            id="percentual"
            v-model="cadOferta.percentual_desconto"
            suffix="%"
            :rules="!tem_desconto_em_reais ? [
              () => cadOferta.percentual_desconto >= 0 || 'O desconto da oferta deve ser de, no mínimo, 0%',
              () => cadOferta.percentual_desconto <= 100 || 'Desconto inválido',
              (v) => !!v || 'Desconto inválido',
            ] : []"
            hint="Percentual a ser subtraido do valor do item"
          />
        </v-flex>
      </v-flex>
      <template v-if="cadOferta.item === 0">
        <v-flex xs12 class="mt-3">
          <h2 class="text-xs-center secondary--text mb-3" style="font-weight: normal;">
            Selecione os itens que não farão parte dessa oferta
          </h2>
        </v-flex>
        <v-flex xs12 sm12 md6 class="ma-0 pa-0" style="flex-direction: row; display: flex;">
          <v-flex xs10 class="pa-0 ma-0">
            <span>Selecione um Item para remover da oferta</span>
              <v-select
                label="Selecione um item"
                :items="todos_itens"
                item-text="nome"
                v-model="item_list"
                outline
                hide-details
                single-line
                return-object
              />
          </v-flex>
          <v-flex xs2 style="justify-content: center; display: flex;" class="pa-0 ma-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="item_list === undefined" @click="ListAdd()" v-on="on" icon color="primary" style="margin-top:2.5em;"><v-icon small>add</v-icon></v-btn>
              </template>
              Adicionar item a lista
            </v-tooltip>
          </v-flex>
        </v-flex>
        <v-flex xs12 sm10 md6 class="ma-0 pa-0">
          <v-layout justify-center wrap>
            <v-flex xs12 class="mt-3">
              <h3 style="text-align: center;" class="grey--text">Itens que não serão ofertados</h3>
            </v-flex>
            <v-flex xs12>
              <v-list style="background-color:#F5F5F5">
                <v-list-tile v-for="(ino, index) in itens_nao_ofertados" :key="index">
                  <v-list-tile-avatar>
                    <svg-filler
                      v-if="ino.categoria.referencia === 'combustivel'"
                      :path="ino.combustivel.icone ? require(`@/assets/combs/${ino.combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                      width="30px"
                      height="30px"
                      :fill="ino.preco ? ino.combustivel.color : 'grey'"
                    />
                    <v-icon v-else :color="ino.categoria.cor">
                      {{ ino.categoria.icone }}
                    </v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ino.nome}}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon @click="removerDalista(index)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-flex>
      </template>
      <v-flex xs12>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              block
              @click="cadDesconto"
              v-on="on"
              color="primary"
              class="mt-4"
              :loading="loading"
              :disabled="disabled"
            >
              <v-icon size="1.8em" class="mr-2">save</v-icon>
              SALVAR
            </v-btn>
          </template>
          Salvar oferta
        </v-tooltip>
      </v-flex>
      </v-layout>
    </v-slide-x-transition>
    <v-tabs
      fixed-tabs
      slider-color="secondary"
      v-model="tabs"
    >
      <v-tab>
        COMBUSTÍVEIS
      </v-tab>
      <v-tab>
        CONVENIÊNCIA
      </v-tab>
      <v-tab>
        DEMAIS ITENS
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs" class="mt-4">
      <v-tab-item>
        <v-layout row wrap class="card-row" justify-start>
          <v-flex
            xs12
            sm12
            md6
            :lg6="drawer"
            :lg4="!drawer"
            :xl4="drawer"
            :xl3="!drawer"
            v-for="(objeto, index) in itens_combustiveis"
            :key="index"
            class="mb-4"
          >
            <item
              v-on:error="showError"
              :item="objeto"
              @editarItem="editarItem"
              @visualizarItem="visualizarItem"
              @deletarItem="abrirDialogConfirmacao"
              @editarDisponibilidade="editarDisponibilidade"
              @carregar="carregar"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-layout row class="card-row">
          <v-flex
            align-self-center
            style="
              justify-content: start;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination_conveniencia.page--"
                slot="activator"
                :disabled="pagination_conveniencia.page == 1"
              >
                <v-icon size="40">arrow_back_ios</v-icon>
              </v-btn>
              <span>Ir para esquerda</span>
            </v-tooltip>
          </v-flex>
          <v-layout
            column
            v-for="(objeto, index) in itens_conveniencia"
            :key="index"
          >
            <item
              v-on:error="showError"
              :item="objeto"
              @editarItem="editarItem"
              @visualizarItem="visualizarItem"
              @deletarItem="abrirDialogConfirmacao"
              @editarDisponibilidade="editarDisponibilidade"
              @carregar="carregar"
            />
          </v-layout>
          <v-flex
            align-self-center
            style="
              justify-content: end;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination_conveniencia.page++"
                slot="activator"
                :disabled="pagination_conveniencia.totalItems <= pagination_conveniencia.page * visibleCards"
              >
                <v-icon size="40">arrow_forward_ios</v-icon>
              </v-btn>
              <span>Ir para Direita</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-layout row class="card-row">
          <v-flex
            align-self-center
            style="
              justify-content: start;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination.page--"
                slot="activator"
                :disabled="pagination.page == 1"
              >
                <v-icon size="40">arrow_back_ios</v-icon>
              </v-btn>
              <span>Ir para esquerda</span>
            </v-tooltip>
          </v-flex>
          <v-layout
            column
            v-for="(objeto, index) in itens"
            :key="index"
          >
            <item
              v-on:error="showError"
              :item="objeto"
              @editarItem="editarItem"
              @visualizarItem="visualizarItem"
              @deletarItem="abrirDialogConfirmacao"
              @editarDisponibilidade="editarDisponibilidade"
              @carregar="carregar"
            />
          </v-layout>
          <v-flex
            align-self-center
            style="
              justify-content: end;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination.page++"
                slot="activator"
                :disabled="pagination.totalItems <= pagination.page * visibleCards"
              >
                <v-icon size="40">arrow_forward_ios</v-icon>
              </v-btn>
              <span>Ir para Direita</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-if="promocao" v-model="promocao"  max-width="500">
      <cad-promocao
        @fechar="promocao = false"
        @showMessage="showInfo"
        @error="showError"
        @carregar="carregar"
      />
    </v-dialog>
    <v-dialog v-if="codigo" v-model="codigo"  max-width="600">
      <listar-codigos @fechar="codigo = false"/>
    </v-dialog>
    <v-dialog v-if="mostrar" v-model="mostrar"  max-width="500">
      <mostrar-combustiveis
        @fechar="mostrar = false"
        @carregar="carregar"
      />
    </v-dialog>
    <v-dialog v-if="dialogTipoDesconto" v-model="dialogTipoDesconto"  max-width="500">
      <tipo-desconto
        @fechar="dialogTipoDesconto = false"
        @success="showInfo"
        @error="showError"
        @carregar="carregar"
      />
    </v-dialog>
    <v-dialog v-if="dialogCadItem" v-model="dialogCadItem"  width="65em" :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <cad-item
        @fechar="dialogCadItem = false, itemSelecionado = undefined"
        @success="showInfo"
        @error="showError"
        @carregar="carregar"
        :itemSelecionado="itemSelecionado"
      />
    </v-dialog>
    <v-dialog v-if="dialogDetalhesItem" v-model="dialogDetalhesItem"  width="65em" :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <detalhes-item
        :item="itemSelecionado"
        @fechar="
          dialogDetalhesItem = false,
          itemSelecionado = undefined
        "
      />
    </v-dialog>
    <v-dialog
      v-if="dialogConfirmacaoExclusao"
      v-model="dialogConfirmacaoExclusao"
      width="55em"
    >
      <confirmacao-exclusao
        @confirmado="deletarItem"
        @fechar="dialogConfirmacaoExclusao = false, itemSelecionado = undefined"
      >
        <template v-slot:principal>
          <h2
            v-if="itemSelecionado"
            class="error--text text-xs-center mb-2"
          >
            Tem certeza que você deseja excluir {{ itemSelecionado.nome }}?
          </h2>
        </template>
      </confirmacao-exclusao>
    </v-dialog>
    <v-dialog
      v-if="dialogDisponibilidadeItem"
      v-model="dialogDisponibilidadeItem"
      width="45em"
    >
      <item-disponibilidade
        :item="itemSelecionado"
        @fechar="
          dialogDisponibilidadeItem = false,
          itemSelecionado = undefined
        "
        @success="showInfo"
        @error="showError"
        @carregar="carregar"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbarerror.active"
      :color="snackbarerror.color"
      :multi-line="snackbarerror.multiLine"
      :timeout="snackbarerror.timeout"
      :vertical="snackbarerror.vertical"
    >
      {{ snackbarerror.errorText }}
      <v-btn
        flat
        @click="snackbarerror.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Item from '@/components/dialogs/Item'
import CadPromocao from '@/components/cadastros/CadPromocao'
import CadItem from '@/components/cadastros/CadItem'
import ListarCodigos from '@/components/cadastros/ListCodigosPromocionais'
import MostrarCombustiveis from '@/components/dialogs/DialogMostrarCombustivel'
import TipoDesconto from '@/components/dialogs/TipoDesconto'
import DetalhesItem from '@/components/dialogs/DetalhesItem'
import ItemDisponibilidade from '@/components/dialogs/ItemDisponibilidade.vue'
import ConfirmacaoExclusao from '@/components/dialogs/ConfirmacaoExclusao.vue'
import { VMoney } from 'v-money'

export default {
  directives: { money: VMoney },
  components: {
    CadPromocao,
    ListarCodigos,
    MostrarCombustiveis,
    TipoDesconto,
    Item,
    CadItem,
    DetalhesItem,
    ItemDisponibilidade,
    ConfirmacaoExclusao
  },
  data () {
    return {
      lagura_tela: 0,
      currentIndex: 0,
      visibleCards: 1,
      mostrar: false,
      dialogCadItem: false,
      dialogDetalhesItem: false,
      dialogDisponibilidadeItem: false,
      combustivelSelecionado: null,
      dialogConfirmacaoExclusao: false,
      ofertas: [],
      itens: [],
      itens_conveniencia: [],
      itens_combustiveis: [],
      todos_itens: [],
      categorias: [],
      item_list: undefined,
      categoria_list: undefined,
      oferta: false,
      dialogTipoDesconto: false,
      promocao: false,
      codigo: false,
      percentual: 1,
      planos: [],
      itens_nao_ofertados: [],
      tem_desconto_em_reais: false,
      desconto_em_reais: '0,00',
      snackbarerror: {
        active: false,
        color: 'error',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        errorText: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      cadOferta: {
        percentual_desconto: null,
        desconto_em_reais: null,
        id_combustivel: null,
        promocao: false,
        data_inicio: null,
        data_fim: null,
        qtd_litros: null,
        consumo: [0, 200],
        tipos_pagamento: [],
        para_assinantes: false,
        id_rede: null,
        cnpj: null,
        combustiveis_nao_ofertados: [],
        itens_nao_ofertados: [],
        categoria: 0,
        disponivel: true,
        item: 0,
        novo: true
      },
      pagination: {
        page: 1,
        totalItems: 0
      },
      pagination_conveniencia: {
        page: 1,
        totalItems: 0
      },
      tabs: 0,
      itemSelecionado: undefined
    }
  },
  watch: {
    ready (val) {
      if (val) {
        // this.$store.dispatch('carregarCombustiveisSilenciados')
        // this.carregarTiposPagamento()
        this.carregar()
        if (this.oferta) this.pegarPlanos()
      }
    },
    tem_desconto_em_reais (val) {
      if (val) {
        this.cadOferta.desconto_em_reais = '0,00'
        this.cadOferta.percentual_desconto = null
      } else {
        this.cadOferta.percentual_desconto = 0
        this.cadOferta.desconto_em_reais = null
      }
      this.verificarOferta(true)
    },
    desconto_em_reais (val) {
      if (val !== '0,00' && this.tem_desconto_em_reais) {
        this.cadOferta.desconto_em_reais = this.formatarValor(val)
      }
    },
    'cadOferta.item' (val) {
      if (val !== 0) {
        this.itens_nao_ofertados = []
      }
    },
    'cadOferta.categoria' () {
      if (this.oferta) this.pegarTodosItens()
    },
    tela (val) {
      this.ajustarTela(val)
      this.pagination.page = 1
      this.pagination_conveniencia.page = 1
      this.carregar()
    },
    tabs (val) {
      this.carregar()
    },
    pagination: {
      handler (val) {
        if (this.posto && this.tabs === 2) this.pegarItens()
      },
      deep: true
    },
    pagination_conveniencia: {
      handler (val) {
        if (this.posto && this.tabs === 1) this.pegarItensConveniencia()
      },
      deep: true
    },
    oferta (val) {
      if (val) {
        this.pegarCategorias()
        this.pegarTodosItens()
        this.pegarPlanos()
        this.verificarOferta(false)
      }
    }
  },
  beforeMount () {
    this.ajustarTela(this.$vuetify.breakpoint)
    if (this.ready) {
      this.carregar()
      // this.$store.dispatch('carregarCombustiveisSilenciados')
      // this.carregarTiposPagamento()
      // this.$store.dispatch('carregarCombustiveis')
    }
    if (this.posto) {
      if (this.oferta) this.pegarPlanos()
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    tela () {
      return this.$vuetify.breakpoint
    },
    posto () {
      return this.$store.getters.posto
    },
    redes () {
      return this.$store.getters.redes
    },
    ready () {
      return !!this.posto && !!this.posto.precificado
    },
    disabled () {
      if (!this.cadOferta.categoria) return true
      else if (!this.tem_desconto_em_reais && (this.cadOferta.percentual_desconto < 1 || this.cadOferta.percentual_desconto > 100)) return true
      else if (this.tem_desconto_em_reais && (this.cadOferta.desconto_em_reais <= 0 || this.cadOferta.desconto_em_reais >= 4)) return true
      return false
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    smartLockAtivo () {
      const pessoa = this.$store.getters.pessoa
      if (pessoa) {
        return pessoa.smartlock_posto
      } else {
        return false
      }
    },
    rede () {
      if (this.posto.rede) {
        const rede = this.redes.map((r) => {
          if (this.posto.rede === r.id_rede) {
            return r
          }
        })
        return rede ? rede[0] : undefined
      }
      return undefined
    },
    tem_assinatura () {
      if (this.planos.length > 0) return true
      return false
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.visibleCards == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    pageConvenienvia () {
      if (this.visibleCards == null ||
        this.pagination_conveniencia.totalItems == null
      ) return 0

      return Math.ceil(this.pagination_conveniencia.totalItems / this.pagination_conveniencia.rowsPerPage)
    },
    drawer () {
      return this.$store.getters.drawer
    }
  },
  methods: {
    carregar () {
      if (this.tabs === 0) this.pegarItensCombustiveis()
      else if (this.tabs === 1) this.pegarItensConveniencia()
      else if (this.tabs === 2) this.pegarItens()
    },
    formatarValor (valor) {
      return Number(valor.replace('R$ ', '').replaceAll('.', '').replace(',', '.'))
    },
    editarItem (item) {
      this.itemSelecionado = item
      this.dialogCadItem = true
    },
    visualizarItem (item) {
      this.itemSelecionado = item
      this.dialogDetalhesItem = true
    },
    editarDisponibilidade (item) {
      this.itemSelecionado = item
      this.dialogDisponibilidadeItem = true
    },
    abrirDialogConfirmacao (item) {
      this.itemSelecionado = item
      this.dialogConfirmacaoExclusao = true
    },
    deletarItem () {
      const data = {
        method: 'DELETE',
        body: {
          posto: this.posto.cnpj
        },
        id: this.itemSelecionado.id
      }
      this.$store.dispatch('itens', data).then(() => {
        this.dialogConfirmacaoExclusao = false
        this.pagination.page = 1
        this.pagination_conveniencia.page = 1
        this.itemSelecionado = undefined
        this.carregar()
        this.showInfo('Item deletado com sucesso.')
      })
    },
    ajustarTela (val) {
      if (val) {
        if (val.xs) this.visibleCards = 1
        else if (val.sm) this.visibleCards = 1
        else if (val.md) this.visibleCards = 2
        else if (val.lg) this.visibleCards = 2
        else if (val.xl) this.visibleCards = 3
      }
    },
    pegarPlanos () {
      const data = { ativo: true }
      data.cnpj = this.posto.cnpj
      this.$store.dispatch('pegarPlanos', data).then(json => {
        this.planos = json
      })
    },
    cadDesconto () {
      if (
        !this.tem_desconto_em_reais && (this.cadOferta.percentual_desconto < 0 ||
        this.cadOferta.percentual_desconto > 100 || this.cadOferta.percentual_desconto === '')
      ) {
        this.showError('Percentual de desconto inválido.')
        return
      }

      if (
        this.tem_desconto_em_reais && this.cadOferta.desconto_em_reais <= 0
      ) {
        this.showError('O valor do desconto em reais é inválido.')
        return
      }

      if (this.cadOferta.item === 0 && this.itens_nao_ofertados.length > 0) {
        this.cadOferta.itens_nao_ofertados = []
        this.cadOferta.combustiveis_nao_ofertados = []

        this.itens_nao_ofertados.map(
          (ino) => {
            if (ino.categoria.referencia === 'combustivel') {
              this.cadOferta.combustiveis_nao_ofertados.push(ino.combustivel.id_combustivel)
            } else {
              this.cadOferta.itens_nao_ofertados.push(ino.id)
            }
          }
        )
      }

      this.cadOferta.posto = this.posto.cnpj
      this.$store.dispatch('ofertas', {
        method: 'POST',
        body: {
          ...this.cadOferta,
          item: this.cadOferta.item === 0 ? null : this.cadOferta.item,
          categoria: this.cadOferta.categoria,
          percentual_desconto: this.tem_desconto_em_reais ? null : this.cadOferta.percentual_desconto,
          desconto_em_reais: this.tem_desconto_em_reais ? this.cadOferta.desconto_em_reais : null
        }
      }).then(() => {
        this.oferta = false
        this.item_list = undefined
        this.categoria_list = undefined
        this.cadOferta.percentual_desconto = null
        this.cadOferta.id_rede = null
        this.cadOferta.cnpj = null
        this.cadOferta.para_assinantes = false
        this.cadOferta.item = 0
        this.cadOferta.categoria = 0
        this.itens_nao_ofertados = []
        this.cadOferta.itens_nao_ofertados = []
        this.carregar()
        this.showInfo('Oferta cadastrada com sucesso')
      })
    },
    showInfo (text) {
      this.snackbarerror.color = 'info'
      this.snackbarerror.errorText = text
      this.snackbarerror.active = true
    },
    showError (error) {
      this.snackbarerror.color = 'error'
      this.snackbarerror.errorText = error
      this.snackbarerror.active = true
    },
    toggle (index) {
      alert(index)
    },
    setOfertas (combustivel, ofertas) {
      combustivel = { ...combustivel, ofertas: ofertas }
    },
    carregarTiposPagamento () {
      this.$store.dispatch('carregarTiposPagamento')
    },
    ListAdd () {
      let itemExiste = false
      for (let i in this.itens_nao_ofertados) {
        if (this.itens_nao_ofertados[i].id === this.item_list.id) {
          itemExiste = true
        }
      }
      if (itemExiste) {
        this.showError('Esse item já foi inserido.')
      } else {
        this.itens_nao_ofertados.push(this.item_list)
      }
    },
    removerDalista (index) {
      this.itens_nao_ofertados.splice(index, 1)
    },
    pegarItens () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj,
          page: this.pagination.page,
          page_size: this.visibleCards,
          is_conveniencia: false,
          combustivel__isnull: true
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens = json.results
        this.pagination.totalItems = json.count
      })
    },
    pegarItensConveniencia () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj,
          page: this.pagination_conveniencia.page,
          page_size: this.visibleCards,
          is_conveniencia: true,
          combustivel__isnull: true
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens_conveniencia = json.results
        this.pagination_conveniencia.totalItems = json.count
      })
    },
    pegarItensCombustiveis () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj,
          categoria__referencia__iexact: 'combustivel',
          combustivel__isnull: false
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens_combustiveis = json
      })
    },
    verificarOferta (mostrarError) {
      const data = {}
      if (this.tem_desconto_em_reais) {
        data.percentual_desconto__isnull = false
      } else {
        data.desconto_em_reais__isnull = false
      }
      this.$store.dispatch('verificarOferta', data).then(json => {
        if (json.existe) {
          this.tem_desconto_em_reais = !this.tem_desconto_em_reais
          if (mostrarError) {
            this.showError('Você não pode usar oferta ou promoções com desconto em percentual e em reais simultaneamente.')
          }
        }
      })
    },
    pegarTodosItens () {
      const data = {
        method: 'GET',
        parameters: {
          posto: this.posto.cnpj
        }
      }
      if (this.cadOferta.categoria) {
        data.parameters.categoria = this.cadOferta.categoria
      }
      this.$store.dispatch('itens', data).then(json => {
        this.todos_itens = json
      })
    },
    pegarCategorias () {
      this.$store.dispatch('pegarCategorias').then(json => {
        this.categorias = json
        if (json.length > 0) this.cadOferta.categoria = json[0].id
      })
    }
  }
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

</style>
